exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tap-editor-media{display:inline-block;max-width:22rem}[dir] .tap-editor-media{margin:0 .5rem}[dir] .tap-editor-media .tap-attachment{margin:0}", ""]);

